import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=3fcec98e&"
import script from "./CourseShow.vue?vue&type=script&lang=js&"
export * from "./CourseShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports